import crud, { ApiResponse } from "@/api/crud";

export interface Invitation {
  id: number;
  business_profile_id: number;
  type: "new_renter" | "existing_renter";
  opaque_id: string;
  agreement_id: number;
  meta_id: number | null;
  is_active: boolean;
  created_at: string;
}

export interface InvitationAgreement {
  id: number;
  office: number;
  renter: number | null;
  price: number;
  deposit: number | null;
  description: string | null;
  start_date: string;
  end_date: string;
  business_profile: number | null;
  requisite: number;
  number: string | null;
  renterRequisite: number | null;
  meetingHours: number;
  scan: string | null;
  is_deleted: number;
  workplace_id: number | null;
  onec_counterparty_id: string | null;
  onec_contract_id: string | null;
  is_hidden: number;
  office_name: string;
  location_address: string;
  business_profile_name: string;
}

export interface InvitationMeta {
  id: number;
  renter_name: string;
  address: string;
  ogrn: number;
  inn: number;
  kpp: number;
  bik: string;
  bank_account: string;
  correspondent_account: string;
  bank_name: string;
  phone_number: string;
  email: string;
}

export interface InvitationResponse {
  invitation: Invitation;
  agreement: InvitationAgreement;
  meta?: InvitationMeta | null;
}

export interface AcceptNewRenterParams {
  renter_name: string;
  address: string;
  ogrn: number;
  inn: number;
  kpp: number;
  bik: string;
  bank_account: string;
  correspondent_account: string;
  bank_name: string;
  phone_number: string;
  email: string;
}

export interface AcceptInvitationResponse {
  success: boolean;
}

export function InvitationsAPI(baseUrl: string) {
  return {
    get: async (opaqueId: string) => {
      return (await crud.get(
        `${baseUrl}/invitations/${opaqueId}`,
        undefined,
        true,
      )) as ApiResponse<InvitationResponse>;
    },
    acceptNewRenter: async (
      opaqueId: string,
      params: AcceptNewRenterParams,
    ) => {
      return (await crud.post(
        `${baseUrl}/invitations/${opaqueId}/new-renter/`,
        params,
        true,
      )) as ApiResponse<AcceptInvitationResponse>;
    },
    acceptExistingRenter: async (opaqueId: string) => {
      return (await crud.post(
        `${baseUrl}/invitations/${opaqueId}/existing-renter/`,
        {},
        true,
      )) as ApiResponse<AcceptInvitationResponse>;
    },
  };
}
